/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChevronCircleUp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 12c0 5.514-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2s10 4.486 10 10zm-1.818 0c0-4.51-3.67-8.182-8.182-8.182-4.512 0-8.182 3.671-8.182 8.182 0 4.51 3.67 8.182 8.182 8.182 4.512 0 8.182-3.671 8.182-8.182zm-2.475 1.293-1.414 1.414L12 10.414l-4.293 4.293-1.414-1.414L12 7.586z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChevronCircleUp as ChevronCircleUp };
